var React = require('react');

function TeamHeroFlag3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m59 31.6649688h206.188052l67.811948 143.0000002h-274z","fill":"#4eb684","fillRule":"evenodd","opacity":".05","transform":"translate(-59 -31.664969)"}));
}

TeamHeroFlag3.defaultProps = {"height":"143","viewBox":"0 0 274 143","width":"274"};

module.exports = TeamHeroFlag3;

TeamHeroFlag3.default = TeamHeroFlag3;
